import React from "react";

export const SnagImg = ({ fillColor }) => {
  return (
    <svg
      width="171px"
      height="114px"
      viewBox="0 0 171 114"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>33899352-30D6-46B9-A16A-A82CF47B0BD8</title>
      <g
        id="↳-Wizard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1.5.1-Wizard---Life-insurance-Copy"
          transform="translate(-662.000000, -307.000000)"
          fillRule="nonzero"
        >
          <g
            id="undraw_personal_information_re_vw8a"
            transform="translate(662.000000, 307.000000)"
          >
            <path
              d="M171,60.5000204 C171,83.597414 156.360488,103.277295 135.855401,110.765668 C132.736052,111.907101 129.516144,112.752241 126.238319,113.289894 C117.220782,114.768835 107.975222,113.929191 99.3716385,110.849971 C78.7368061,103.423204 63.9902678,83.6768533 64,60.4886719 C64,30.9534494 87.9534128,7 117.5,7 C128.666585,6.98381531 139.555898,10.477281 148.628937,16.9867163 C162.174122,26.6912888 171,42.5645611 171,60.5000204 Z"
              id="Path"
              fill="#EFF1FB"
            ></path>
            <path
              d="M135,110.684854 C131.922013,111.854807 128.744799,112.721064 125.510438,113.272151 C116.612469,114.788045 107.489503,113.927421 99,110.771264 L101.437925,100.609851 L101.585086,100 L106.560216,100.019941 L131.554207,100.112997 L131.87415,101.095073 L135,110.684854 Z"
              id="Path"
              fill="#2F2E41"
            ></path>
            <rect
              id="effaf695-3865-40c6-8918-ced0238239c2"
              fill="#E6E6E6"
              x="0"
              y="0"
              width="47"
              height="53"
            ></rect>
            <rect
              id="f33d627f-c769-4bde-9d74-ef156faf640e"
              fill="#FFFFFF"
              x="1"
              y="1"
              width="45"
              height="51"
            ></rect>
            <circle
              id="b5fd4af9-5b07-4da2-8ccf-5b3d4ac887f6"
              fill="#E6E6E6"
              cx="24.5"
              cy="47.5"
              r="2.5"
            ></circle>
            <rect
              id="f05405a0-af73-4807-bbd1-d761cdd06c65"
              fill="#E6E6E6"
              x="8"
              y="19"
              width="15"
              height="1"
            ></rect>
            <rect
              id="a05e4a04-50b7-46b0-b842-8db21044ae7a"
              fill={fillColor}
              x="9"
              y="23"
              width="21"
              height="1"
            ></rect>
            <rect
              id="bdce3bac-3998-4a72-bc14-4aa79023038d"
              fill="#E6E6E6"
              x="9"
              y="28"
              width="19"
              height="1"
            ></rect>
            <rect
              id="e1177af0-2f80-4461-b67e-43945f3b6fee"
              fill={fillColor}
              x="9"
              y="32"
              width="30"
              height="1"
            ></rect>
            <rect
              id="b290cdc3-2096-427b-bfd4-6b657da823ea"
              fill="#E6E6E6"
              x="9"
              y="36"
              width="24"
              height="1"
            ></rect>
            <g
              id="b96c6486-fa38-4cba-8e5e-13dca7f44a0c"
              transform="translate(58.000000, 18.000000)"
            >
              <path
                d="M8.29540539,67.1753015 C8.47339726,67.3573971 8.63671152,67.5531733 8.78383299,67.7608138 L31.663506,67.203276 L34.3326297,62.3454755 L42.219976,65.3992475 L38.3334575,74.4563098 C37.6885693,75.9592139 36.1250977,76.8578081 34.4959288,76.6619021 L8.64568195,73.5516932 C7.39718459,75.1258873 5.30093721,75.7664039 3.38087335,75.1603762 C1.46080948,74.5543484 0.117584212,72.8282348 0.00730970466,70.825173 C-0.102964803,68.8221113 1.04272216,66.9600755 2.88474805,66.1485963 C4.72677394,65.337117 6.88076767,65.7455236 8.2945889,67.1743257 L8.29540539,67.1753015 Z"
                id="b0fbfc35-67c9-42b4-b2fe-33d0d7288754-346"
                fill="#9F616A"
              ></path>
              <path
                d="M39.0903521,39.4366867 L49.7977105,35.9416662 L52.9425245,31.6461202 L68.2462625,32.5481344 L70.4930948,37.5607704 L78.6534772,41.4012432 L77.3993401,64.5979398 L75.2539166,86.3069472 C64.2217563,80.6172313 43.6328316,84.9550302 43.4525494,85.0256202 L39.0903521,39.4366867 Z"
                id="a6a8f1c9-3ab8-4f6f-ba9b-45acc2f7af89-347"
                fill={fillColor}
              ></path>
              <path
                d="M41.3793041,70.8347031 L30.4882342,66.4947557 L30.5346112,66.3016993 C30.5813147,66.1065285 35.2167228,46.8143858 35.8321971,43.7140981 C36.4733094,40.4841845 38.8158349,39.5911156 38.915284,39.5548464 L38.9879521,39.528173 L43.2980685,40.8348413 L45.1910316,55.6484654 L41.3793041,70.8347031 Z"
                id="fc06e97d-785e-4845-9aa0-60a5889f9ce3-348"
                fill={fillColor}
              ></path>
              <path
                d="M64.8952067,85.3526629 C65.1505019,85.3466161 65.4058781,85.360647 65.6589566,85.3946247 L80.8044578,68.305472 L79.0427871,63.0544025 L86.6538314,59.3702289 L90.6799706,68.3664629 C91.3480968,69.8593133 90.94664,71.6122175 89.6946238,72.6688399 L69.8292889,89.4328705 C70.1391742,91.4150013 69.185306,93.3813138 67.4335923,94.3713809 C65.6818786,95.361448 63.4978271,95.1686851 61.9482176,93.8872454 C60.398608,92.6058057 59.8067776,90.5030709 60.4618003,88.6061023 C61.1168231,86.7091337 62.8820239,85.4137474 64.8952067,85.3526629 L64.8952067,85.3526629 Z"
                id="b248559b-61d8-49e2-8eef-81cc9521c19e-349"
                fill="#9F616A"
              ></path>
              <path
                d="M79.5955382,69.9689678 L73.2776595,55.1675419 L75.7418429,44.8574833 L78.3969229,41.5166477 C78.7900704,41.3492252 79.2356333,41.3533539 79.6255853,41.5280326 C80.6053799,41.9204885 81.4382052,43.1235537 82.1039757,45.1035611 L88.0250376,61.9010961 L79.5955382,69.9689678 Z"
                id="b0e9bc84-32e8-4599-bd8d-d35670d3692b-350"
                fill={fillColor}
              ></path>
              <path
                d="M46.8165913,26.1614361 L46.8165913,15.0025473 C46.7989044,9.66038085 49.6440055,4.71457363 54.2802552,2.02816339 C58.916505,-0.658246846 64.6395467,-0.677130471 69.293566,1.9786258 C73.9475853,4.63438207 76.8255259,9.56130566 76.8433769,14.9034721 C76.8433769,14.9364939 76.8433769,14.969519 76.8433769,15.0025473 L76.8433769,26.1614361 C76.8420354,27.270253 75.939846,28.1688138 74.8265515,28.1700686 L48.8334179,28.1700686 C47.7201233,28.1688138 46.817934,27.270253 46.8165913,26.1614361 Z"
                id="b58b0f1b-b11b-4f57-8de2-a939101b4938-351"
                fill="#2F2E41"
              ></path>
              <ellipse
                id="ba54abe3-4119-45e5-b5c1-150877d750f7"
                fill="#9F616A"
                cx="58.7448549"
                cy="16.9471735"
                rx="11.0071755"
                ry="10.9629048"
              ></ellipse>
              <path
                d="M43.2649188,15.8952844 C43.2722982,9.36563815 48.5851576,4.07414704 55.1411721,4.06679725 L57.3821256,4.06679725 C63.9381135,4.07414721 69.2509261,9.36566445 69.2582156,15.8952844 L69.2582156,16.1184297 L64.5225418,16.1184297 L62.9073505,11.6132377 L62.5843449,16.1184297 L60.1371446,16.1184297 L59.3222821,13.845666 L59.158983,16.1184297 L43.2649188,16.1184297 L43.2649188,15.8952844 Z"
                id="b6bcc4bf-1738-426f-8fbf-3ee273a728b5-352"
                fill="#2F2E41"
              ></path>
              <path
                d="M57.6616936,29.4249841 C57.2079944,28.8130816 57.146608,27.9963286 57.5037834,27.3239708 C59.8783155,22.8256098 63.2029218,14.5134493 58.7900904,9.38728907 L58.4736167,9.01939216 L71.2854106,9.01939216 L71.2854106,28.1770297 L59.6469207,30.2222567 C59.529126,30.2430244 59.4097381,30.2536467 59.2901122,30.2536467 C58.6455903,30.2536467 58.0402104,29.9456271 57.6625101,29.425472 L57.6616936,29.4249841 Z"
                id="be96ad09-85ff-4345-abef-5a49918f7c18-353"
                fill="#2F2E41"
              ></path>
            </g>
            <g
              id="b2dad932-78e1-44e1-9682-073c8202f887"
              transform="translate(18.000000, 5.000000)"
              fill={fillColor}
            >
              <path
                d="M5.50028092,0 C2.46271567,-0.000155148429 0.000156382504,2.46215159 0,5.49971684 C-0.000156382504,8.5372821 2.46214936,10.9998424 5.49971461,11 C8.53727986,11.0001576 10.9998411,8.53785288 11,5.50028762 L11,5.5 C11,4.0413089 10.4205391,2.64236161 9.38908876,1.61091124 C8.35763839,0.579460865 6.9586911,0 5.5,0 L5.50028092,0 Z M5.50028092,1.64985068 C6.41147014,1.64985068 7.15014163,2.38850879 7.15014163,3.29969801 C7.15014163,4.21088722 6.41148351,4.94955871 5.5002943,4.94955871 C4.58910508,4.94955871 3.85043359,4.2109006 3.85043359,3.29971138 L3.85043359,3.29971138 C3.85043359,2.38852332 4.58909285,1.64985068 5.50028092,1.64985068 L5.50028092,1.64985068 Z M5.50028092,9.59298877 C4.17694632,9.58693228 2.94195403,8.92785094 2.20028192,7.83187027 C2.22678119,6.73186894 4.40028125,6.12638234 5.50028092,6.12638234 C6.60028059,6.12638234 8.77378233,6.73186894 8.80028159,7.83187027 C8.0578324,8.9269884 6.82333154,9.58580715 5.50028092,9.59298877 Z"
                id="e043db59-b600-449e-8c52-e1eb73379667-354"
              ></path>
            </g>
            <path
              d="M23.9034718,48.1315523 C26.0948487,44.0999766 31.3444497,41.5468564 35.6387397,43.8481553 C37.5716796,44.8838535 39.1082311,46.7159303 39.5959943,48.8813335 C40.1620327,51.396786 38.9693091,53.7953389 37.7380949,55.9086243 C37.0698463,57.0557018 36.3375544,58.1793995 35.7844541,59.3893105 C35.2117851,60.6422472 34.8024585,62.0903412 35.233618,63.4533583 C35.6217585,64.6812914 36.595021,65.574437 37.6607902,66.2308609 C38.8370791,66.9279018 40.0882386,67.488917 41.3903358,67.9031749 C44.0706591,68.7980925 46.8978272,69.1653014 49.7167592,68.9846588 C51.1177743,68.8891064 52.5069821,68.6636554 53.8666286,68.311187 C55.3129374,67.9410049 56.732238,67.4717828 58.1809726,67.1097187 C60.5997351,66.5065491 63.3576355,66.2066691 65.6512227,67.4182038 C67.8794729,68.5956428 68.8766707,71.0581658 69.1850807,73.4537962 C69.754677,77.8774727 68.0075593,82.4680559 64.8531087,85.5658959 C63.339684,87.0521447 61.4352077,88.2800778 59.3609199,88.7824214 C57.5510528,89.220795 55.2270613,89.1927066 53.7867364,87.834398 C52.179511,86.3184372 52.5576246,83.8875745 53.8341219,82.2881604 C55.4635036,80.2474502 58.2238298,79.7572836 60.6870668,79.7076012 C63.4891181,79.6510998 66.2885818,80.0699901 69.0890159,79.8095637 C70.4559378,79.7027684 71.7971762,79.3779799 73.0622814,78.8474149 C74.1744793,78.3562791 75.1889455,77.6670984 76.056624,76.8131991 C77.7854667,75.1269221 78.9515056,72.880501 79.5312906,70.5447816 C80.2294584,67.7359435 80.0772749,64.7839033 79.5353337,61.9625634 C79.2464795,60.5077514 78.8745446,59.0708162 78.4213703,57.6588714 C78.2342542,57.0630081 77.2970565,57.3179142 77.4856281,57.9178365 C79.1546325,63.2309243 80.0851995,69.3744865 76.8605601,74.3074882 C75.5261096,76.399445 73.4472364,77.901768 71.0476702,78.5082436 C68.2567779,79.2046082 65.3282574,78.8604037 62.49095,78.7568177 C59.7930497,78.6582648 56.8305669,78.764611 54.5178961,80.3421064 C52.6206975,81.6359579 51.293742,84.0970197 51.8672196,86.4203996 C52.4201582,88.6609757 54.5649582,89.7974998 56.7100816,89.9725245 C58.9608117,90.1566414 61.1756387,89.3982551 63.0658832,88.2123734 C66.9979087,85.745629 69.6123588,81.4073542 70.1594752,76.8078412 C70.4445968,74.4112366 70.1544617,71.8297033 69.071873,69.6543962 C68.501415,68.4768337 67.613528,67.4834232 66.5090133,66.7869459 C65.4076645,66.1090904 64.1355338,65.7754394 62.8579045,65.6574033 C59.9552601,65.3890212 57.1664702,66.3894872 54.4129365,67.154855 C53.0063286,67.5645403 51.5645385,67.8408438 50.106517,67.9801338 C48.691423,68.0978401 47.2681958,68.074563 45.8576718,67.9106435 C44.4580521,67.7448567 43.0787,67.4375166 41.7406326,66.9933062 C40.4294199,66.5863562 39.1739832,66.0165504 38.003486,65.2971251 C36.9708704,64.6342069 36.0778237,63.6847222 36.027042,62.3908707 C35.9718937,60.9879129 36.6765305,59.6755522 37.3467199,58.4927554 C38.6707643,56.1562242 40.3062916,53.8708366 40.6515749,51.1355478 C40.9540011,48.7428399 39.9949705,46.3845524 38.3389041,44.6779803 C36.6610722,42.9268886 34.3322482,41.9569743 31.9124287,42.001466 C29.4553373,42.0720929 27.1027203,43.1448093 25.2954409,44.7922821 C24.3990864,45.6098674 23.6448064,46.5717859 23.0636327,47.6384632 C22.7642793,48.1890279 23.6018543,48.6811429 23.9015311,48.130091 L23.9034718,48.1315523 Z"
              id="bcfa45dc-2c5a-4ac5-8376-9a2a23e225d0-355"
              fill="#3F3D56"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
